import { render, staticRenderFns } from "./SummaryCardCar.vue?vue&type=template&id=08fa4c5e&scoped=true&"
import script from "./SummaryCardCar.vue?vue&type=script&lang=js&"
export * from "./SummaryCardCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa4c5e",
  null
  
)

export default component.exports